import axios from "axios";

const URL = "https://gateway.hyundaicolombia.co/";

export const politicasAvisosPrivacidad = async () => {
  return await axios.get(
    URL +
      "politicas/avisos-privacidad"
  );
};

export const politicasCalidad = async () => {
  return await axios.get(
    URL +
      "politicas/calidad"
  );
};

export const politicasCookies = async () => {
  return await axios.get(
    URL +
      "politicas/cookies"
  );
};

export const politicasPagina = async () => {
  return await axios.get(
    URL +
      "politicas/pagina"
  );
};

export const politicasProteccionDatos = async () => {
  return await axios.get(
    URL +
      "politicas/proteccion"
  );
};

export const politicasTerminosCondiciones = async () => {
  return await axios.get(
    URL +
      "politicas/terminos/condiciones"
  );
};

export const politicasTerminosReserva = async () => {
  return await axios.get(
    URL +
      "politicas/terminos/reserva"
  );
};
